//src/components/common/Layout/Layout.js
import React from 'react';
import { Box } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import { COLORS } from '../../../utils/color';
import Footer from '../Footer';

const pageVariants = {
  initial: { opacity: 0, filter: 'blur(8px)', y: 12 },
  animate: { opacity: 1, filter: 'blur(0px)', y: 0 },
  exit:    { opacity: 0, filter: 'blur(8px)', y: -8 },
};

const pageTransition = {
  duration: 0.38,
  ease: [0.22, 1, 0.36, 1],
};

const Layout = ({ children, onSignInClick, onContactClick }) => {
  const location = useLocation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: '#000000',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header
        onSignInClick={onSignInClick}
        onContactClick={onContactClick}
      />

      <Box sx={{ flex: 1 }}>
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pageTransition}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </Box>

      <Footer />
    </Box>
  );
};

export default Layout;
